export default function initGallery() {
    const carrossel = document.querySelector('.c-galeria__carrossel');
    const slides = document.querySelectorAll('.c-galeria__slide');
    const bullets = document.querySelectorAll('.c-galeria__bullet');
    const fracaoAtual = document.querySelector('.c-galeria__fracao-atual');

    // Novos elementos Desktop
    const miniaturas = document.querySelectorAll('.c-galeria__miniatura-btn');
    const btnPrev = document.querySelector('.c-galeria__nav--prev');
    const btnNext = document.querySelector('.c-galeria__nav--next');

    if (!carrossel || slides.length === 0) return;

    // Função centralizada para fazer scroll até um slide específico
    const scrollToSlide = (index) => {
        const slideWidth = slides[0].offsetWidth;
        carrossel.scrollTo({
            left: index * slideWidth,
            behavior: 'smooth'
        });
    };

    // Função que atualiza todo o UI (Fração, Bullets, Miniaturas e Setas)
    const updateUI = () => {
        const scrollLeft = carrossel.scrollLeft;
        const slideWidth = slides[0].offsetWidth;
        // Calcula qual o slide mais centrado no ecrã
        const indexAtivo = Math.round(scrollLeft / slideWidth);

        // Atualiza a fração (Mobile)
        if (fracaoAtual) {
            fracaoAtual.textContent = indexAtivo + 1;
        }

        // Atualiza os bullets (Mobile)
        bullets.forEach((bullet, idx) => {
            if (idx === indexAtivo) {
                bullet.classList.add('c-galeria__bullet--ativo');
            } else {
                bullet.classList.remove('c-galeria__bullet--ativo');
            }
        });

        // Atualiza as miniaturas (Desktop)
        miniaturas.forEach((miniatura, idx) => {
            if (idx === indexAtivo) {
                miniatura.classList.add('c-galeria__miniatura-btn--ativo');
                miniatura.setAttribute('aria-selected', 'true');

                // Extra: Faz scroll suave na lista de miniaturas caso existam muitas imagens
                miniatura.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            } else {
                miniatura.classList.remove('c-galeria__miniatura-btn--ativo');
                miniatura.setAttribute('aria-selected', 'false');
            }
        });

        // Atualiza o estado das Setas (Desktop)
        if (btnPrev && btnNext) {
            btnPrev.disabled = indexAtivo === 0;
            btnNext.disabled = indexAtivo === slides.length - 1;
        }

        // Acessibilidade: Atualiza aria-hidden dos slides
        slides.forEach((slide, idx) => {
            slide.setAttribute('aria-hidden', idx === indexAtivo ? 'false' : 'true');
        });
    };

    // Ouve o evento de scroll do CSS nativo
    carrossel.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateUI);
    });

    // Eventos de clique nas miniaturas (Desktop)
    miniaturas.forEach((miniatura, index) => {
        miniatura.addEventListener('click', () => {
            scrollToSlide(index);
        });
    });

    // Eventos de clique nas setas (Desktop)
    if (btnPrev) {
        btnPrev.addEventListener('click', () => {
            const indexAtivo = Math.round(carrossel.scrollLeft / slides[0].offsetWidth);
            if (indexAtivo > 0) scrollToSlide(indexAtivo - 1);
        });
    }

    if (btnNext) {
        btnNext.addEventListener('click', () => {
            const indexAtivo = Math.round(carrossel.scrollLeft / slides[0].offsetWidth);
            if (indexAtivo < slides.length - 1) scrollToSlide(indexAtivo + 1);
        });
    }

    // Chamada inicial para desativar a seta "Anterior" ao carregar a página
    updateUI();
}